export const selectWarehouses = (state) => state.warehouses.warehouses;
export const selectWarehousesLoading = (state) => state.warehouses.loading;
export const selectWarehousesError = (state) => state.warehouses.error;
export const selectWarehousesSuccessMessage = (state) =>
  state.warehouses.successMessage;
